import React, { useContext, useEffect, useRef, useState } from 'react';
import { Card, Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { CreatableDropdown } from '../../../../components';
import Dropdown from '../../../../components/Dropdown';
import InputField from '../../../../components/InputField';
import { userContext } from '../../../../contextProvider/Authentication';
import { handleDatePicker, handleDatePost, } from '../../../../Functions/apis';
import axiosInstance from '../../../../services/AxiosInstance';
import SimpleReactValidator from 'simple-react-validator';
import swal from 'sweetalert';

function Experience({ stud_id }) {

    const [keyskill, setKeyskill] = useState(false);
    const [input, setInput] = useState({});
    const [experience, setExperience] = useState([]);
    const [, forceUpdate] = useState();
    const { user } = useContext(userContext);
    const simpleValidator = useRef(new SimpleReactValidator());

    useEffect(() => {
        getExperience();
        // eslint-disable-next-line
    }, []);

    const getExperience = () => {
        var url = stud_id ? `can-experience/?candidate=${stud_id}` : "can-experience/";
        axiosInstance(
            url, {
            method: "GET",
            params: {}
        }).then(res => {
            var db = res?.data?.results;
            db.forEach(ret => {
                ret["started_from"] = handleDatePost(ret?.started_from);
                ret["ended_on"] = handleDatePost(ret?.ended_on);
            })
            setExperience(db);
        }).catch(err => {
            swal("", Object.values(err.response.data), "error", { button: "Ok!", })
        })
    }

    const handleChange = (event, value, name, url) => {
        if (["dropdown"].includes(name)) {
            setInput({ ...input, [value]: event })
        } else if (event.target.type === "checkbox") {
            setInput({ ...input, [event.target.name]: event.target.checked })
        } else {
            setInput({ ...input, [event.target.name]: event.target.value })
        }
        if (event.__isNew__) {
            axiosInstance(
                `${url}/`, {
                method: "POST",
                data: { name: event.name }
            }).then(res => {
                setInput({ ...input, [value]: res.data });
            }).catch(err => {
                setKeyskill(false);
                swal("", Object.values(err.response.data).join(", "), "error", { button: "Ok!", });
            })
        }
    }

    const handleEdit = (res) => {
        setInput(res);
        setKeyskill(true);
    }

    const handleSubmit = () => {
        let valid = simpleValidator.current.allValid();
        if (!valid) {
            simpleValidator.current.showMessages();
            forceUpdate(1);
        } else {
            input["experience_type"] = (input?.experience_type?.id) || null;
            input["job_categories"] = (input?.job_categories?.id) || null;
            input["country"] = (input?.country?.id) || null;
            input["job_title"] = (input?.job_title?.id) || null;
            input["career_level"] = (input?.career_level?.id) || null;
            input["industry"] = (input?.industry?.id) || null;
            input["started_from"] = (input?.started_from && handleDatePicker(new Date(input?.started_from)));
            input["ended_on"] = (input?.ended_on && handleDatePicker(new Date(input?.ended_on)));
            input["candidate"] = stud_id ?? user?.id;
            var method = input?.id ? "PUT" : "POST";
            var url = input?.id ? `can-experience/${input.id}/` : "can-experience/";

            axiosInstance(
                url, {
                method: method,
                data: input
            }).then(res => {
                if (res?.status === 201 || res?.status === 200) {
                    setKeyskill(false);
                    getExperience();
                    setInput({});
                    swal("", `Experience ${res.status === 201 ? "added" : "updated"} successfully`, "success", { button: "Ok!", })
                }
            }).catch(err => {
                setKeyskill(false);
                swal("", Object.values(err.response.data).join(", "), "error", { button: "Ok!", })
            })
        }
    }

    const handleDelete = (id) => {
        axiosInstance(
            `can-experience/${id}/`, {
            method: "DELETE",
        }).then(res => {
            swal("", `Experience deleted successfully`, "success", { button: "Ok!", });
            getExperience();
        }).catch(err => {
            swal("", Object.values(err.response.data).join(", "), "error", { button: "Ok!", });
        })
    }

    const handleClose = () => {
        setKeyskill(false);
        setInput({});
    }

    return (
        <div id="key_skills_bx" className="job-bx bg-white m-b30">
            <div className="d-flex">
                <h5 className="m-b15">Experience</h5>
                <Link
                    to={"#"}
                    data-toggle="modal"
                    data-target="#keyskills"
                    onClick={() => setKeyskill(true)}
                    className="site-button add-btn button-sm"
                >
                    <i className="fa fa-plus m-r5" />
                    Add
                </Link>
            </div>
            <div className="row">
                {
                    experience.map((item) => {
                        return (
                            <div className="col-12 col-md-6" key={item.job_title?.name}>
                                <Card className='mb-2'>
                                    <Card.Body className="p-3">
                                        <div className="d-flex">
                                            <h6>{item.job_title?.name} - {item.experience_type?.name}</h6>
                                            <Link
                                                to={"#"}
                                                onClick={() => handleEdit(item)}
                                                className="site-button add-btn button-sm"
                                                title="Edit"
                                            >
                                                <i className="fa fa-pencil " />
                                            </Link>
                                            <Link
                                                to={"#"}
                                                onClick={() => handleDelete(item?.id)}
                                                className="site-button ml-2 add-btn button-sm btn-danger"
                                                title='Delete'
                                            >
                                                <i className="ti-trash" />
                                            </Link>
                                        </div>
                                        {item.started_from} - {item.ended_on}
                                    </Card.Body>
                                </Card>
                            </div>
                        )
                    })
                }
            </div>


            <Modal show={keyskill} size="lg" onHide={setKeyskill} className="fade modal-bx-info">
                <div className="my-0" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="KeyskillsModalLongTitle">Add Experience</h5>
                            <button type="button" className="close" onClick={handleClose}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <form>
                                <div className="row">
                                    <div className="col-12 col-lg-6 col-md-6">
                                        <div className="form-group">
                                            <CreatableDropdown
                                                url="job-types/"
                                                title='Experience Type'
                                                name="experience_type"
                                                value={input.experience_type}
                                                onChange={handleChange}
                                                required={true}
                                            />
                                            <span className="text-danger font-weight-bold">
                                                {simpleValidator.current.message("experience_type", input.experience_type, "required")}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-6 col-md-6">
                                        <div className="form-group">
                                            <CreatableDropdown
                                                url="job-titles/"
                                                title='Job Title'
                                                name="job_title"
                                                value={input.job_title}
                                                onChange={handleChange}
                                                required={true}
                                            />
                                            <span className="text-danger font-weight-bold">
                                                {simpleValidator.current.message("Job Title", input.job_title, "required")}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-6 col-md-6">
                                        <div className="form-group">
                                            <CreatableDropdown
                                                url="job-categories"
                                                title='Job Category'
                                                name="job_categories"
                                                value={input.job_categories}
                                                onChange={handleChange}
                                                required={true}
                                            />
                                            <span className="text-danger font-weight-bold">
                                                {simpleValidator.current.message("job categories", input.job_categories, "required")}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-6 col-md-6">
                                        <div className="form-group">
                                            <InputField
                                                label="Company Name"
                                                name="company_name"
                                                value={input.company_name}
                                                onChange={handleChange}
                                                required={true}
                                                placeholder="Enter Company Name"
                                            />
                                            <span className="text-danger font-weight-bold">
                                                {simpleValidator.current.message("company name", input.company_name, "required")}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-6 col-md-6">
                                        <div className="form-group">
                                            <InputField
                                                label="Designation"
                                                name="designation"
                                                value={input.designation}
                                                onChange={handleChange}
                                                required={true}
                                                placeholder="Enter Designation"
                                            />
                                            <span className="text-danger font-weight-bold">
                                                {simpleValidator.current.message("designation", input.designation, "required")}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-6 col-md-6">
                                        <div className="form-group">
                                            <label className="mb-0">Starting From <span className="text-danger">*</span></label>
                                            <input
                                                type="date"
                                                name="started_from"
                                                value={input.started_from}
                                                onChange={handleChange}
                                                className="form-control"
                                                style={{
                                                    border: " 1px solid",
                                                    borderRadius: "5px",
                                                    height: "50px"
                                                }}
                                                onKeyPress={(e) => e.preventDefault()}
                                                max={new Date().toISOString().split("T")[0]}
                                            />
                                            <span className="text-danger font-weight-bold">
                                                {simpleValidator.current.message("starting from", input.started_from, "required")}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-6 col-md-6">
                                        <div className="form-group">
                                            <label className="mb-0">Ending In<span className="text-danger">*</span></label>
                                            <input
                                                type="date"
                                                name="ended_on"
                                                value={input.ended_on}
                                                onChange={handleChange}
                                                className="form-control"
                                                style={{
                                                    border: " 1px solid",
                                                    borderRadius: "5px",
                                                    height: "50px"
                                                }}
                                                onKeyPress={(e) => e.preventDefault()}
                                            />
                                            <span className="text-danger font-weight-bold">
                                                {simpleValidator.current.message("ending on", input.ended_on, "required")}
                                            </span>
                                        </div>
                                    </div>

                                    <div className="col-12 col-lg-6 col-md-6">
                                        <div className="form-group">
                                            <Dropdown
                                                url="career-level"
                                                title='Career Level'
                                                name="career_level"
                                                value={input.career_level}
                                                onChange={handleChange}
                                                required={true}
                                            />
                                            <span className="text-danger font-weight-bold">
                                                {simpleValidator.current.message("career level", input.career_level, "required")}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-6 col-md-6">
                                        <div className="form-group">
                                            <Dropdown
                                                url="country"
                                                title='Country'
                                                name="country"
                                                value={input.country}
                                                onChange={handleChange}
                                                required={true}
                                            />
                                            <span className="text-danger font-weight-bold">
                                                {simpleValidator.current.message("country", input.country, "required")}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-6 col-md-6">
                                        <div className="form-group">
                                            <CreatableDropdown
                                                url="industry"
                                                title='Industry'
                                                name="industry"
                                                value={input.industry}
                                                onChange={handleChange}
                                                required={true}
                                            />
                                            <span className="text-danger font-weight-bold">
                                                {simpleValidator.current.message("industry", input.industry, "required")}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-6 col-md-6">
                                        <div className="form-group">
                                            <InputField
                                                label="Company Website"
                                                name="company_website"
                                                value={input.company_website}
                                                onChange={handleChange}
                                                required={true}
                                                placeholder="Enter Company Website"
                                            />
                                            <span className="text-danger font-weight-bold">
                                                {simpleValidator.current.message("Company Website", input.company_website, "required")}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-6 col-md-6">
                                        <div className="form-group">
                                            <InputField
                                                label="Achievements"
                                                name="achievements"
                                                value={input.achievements}
                                                onChange={handleChange}
                                                required={false}
                                                placeholder="Enter Achievements"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-6 col-md-6">
                                        <div className="form-group">
                                            <InputField
                                                label="Starting Salary"
                                                name="starting_salary"
                                                value={input.starting_salary}
                                                type="number"
                                                onChange={handleChange}
                                                required={true}
                                                placeholder="Enter Starting Salary"
                                                onKeyPress={e => e.target.value.length >= 8 && e.preventDefault()}
                                            />
                                            <span className="text-danger font-weight-bold">
                                                {simpleValidator.current.message("Starting Salary", input.starting_salary, "required")}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-6 col-md-6">
                                        <div className="form-group">
                                            <InputField
                                                label="Ending Salary"
                                                name="ending_salary"
                                                type="number"
                                                value={input.ending_salary}
                                                onChange={handleChange}
                                                required={true}
                                                placeholder="Enter Ending Salary"
                                                onKeyPress={e => e.target.value.length >= 8 && e.preventDefault()}
                                            />
                                            <span className="text-danger font-weight-bold">
                                                {simpleValidator.current.message("Ending Salary", input.ending_salary, `required|gt:${input.starting_salary}`)}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-6 col-md-6">
                                        <div className="form-group">
                                            <input
                                                type="checkbox"
                                                name="hide_salary"
                                                className="mr-2"
                                                onChange={handleChange}
                                                value={input.hide_salary}
                                                checked={input.hide_salary}
                                            />
                                            Hide my salary from companies
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-12 col-md-12">
                                        <div className="form-group">
                                            <InputField
                                                label="Description"
                                                name="description"
                                                textType="textarea"
                                                value={input.description}
                                                onChange={handleChange}
                                                required={false}
                                                placeholder="Enter Description"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="site-button" onClick={handleClose}>Cancel</button>
                            <button
                                type="button"
                                className="site-button"
                                onClick={() => handleSubmit()}
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>

        </div>
    );
}

export default Experience;